<template>
  <div>
    <mia-car-edit-shared-page-header />

    <mia-owns-car>
      <mia-is-allowed to="show_car_provisions">
        <template #no>
          <mia-dealer-feature-notice feature="show_car_provisions" />
        </template>

        <template #yes>
          <mia-car-edit-opos-general-data-form
            ref="generalDataForm"
            class="mt-8"
            data-highlight="basisdaten"
          />

          <mia-car-edit-opos-debts-form
            v-if="canBookDebts"
            class="mt-16"
            data-highlight="forderungen"
          >
            <template #before>
              <mia-notice
                v-if="!hasInvoiceDateSold && debtorsWithOptionalInvoiceDateSold.length > 0"
                type="info"
                class="mb-6"
                permanent
              >
                <mia-streamline-icon
                  src="information-circle"
                  class="w-5 h-5 inline fill-current text-blue-600 relative -mt-1 mr-2"
                /> Es können nur Forderungen mit {{ debtorsWithOptionalInvoiceDateSold.length === 1 ? 'dem Debitor' : 'den Debitoren' }} {{ formatAsList(debtorsWithOptionalInvoiceDateSold, 'item_title', { type: 'disjunction' }) }} gebucht werden.<br><br>Forderungen mit anderen Debitoren können erst gebucht werden, wenn ein <a
                  href="#"
                  @click.prevent="focusInvoiceDateSoldField"
                >VK-Rechnungsdatum</a> hinterlegt wurde.
              </mia-notice>
            </template>
          </mia-car-edit-opos-debts-form>
          <mia-notice
            v-else
            type="warning"
            title="Achtung"
            class="mt-16"
            permanent
          >
            Forderungen können erst gebucht werden, wenn ein <a
              href="#"
              @click.prevent="focusInvoiceDateSoldField"
            >VK-Rechnungsdatum</a> hinterlegt wurde.
          </mia-notice>
        </template>
      </mia-is-allowed>
    </mia-owns-car>
  </div>
</template>

<script>
import GeneralDataForm from '@/components/cars/edit/forms/opos/GeneralDataForm.vue'
import Notice from '@/components/cars/edit/Notice.vue'
import { isEmpty, handleEmptyDate } from '@/helpers/utils'
import DebtsForm from '@/components/cars/edit/forms/opos/DebtsForm.vue'
import HighlightsElements from '@/mixins/HighlightsElements'
import SharedPageHeader from '@/components/cars/edit/SharedPageHeader.vue'
import { getDebtors } from '@/api/dealer'
import FormattingHelpers from '@/mixins/FormattingHelpers'

export default {
  name: 'MiaCarEditOpos',

  components: {
    'mia-car-edit-opos-debts-form': DebtsForm,
    'mia-car-edit-opos-general-data-form': GeneralDataForm,
    'mia-notice': Notice,
    'mia-car-edit-shared-page-header': SharedPageHeader
  },

  mixins: [HighlightsElements, FormattingHelpers],

  data: () => ({
    debtors: []
  }),

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    },

    hasInvoiceDateSold() {
      return !isEmpty(handleEmptyDate(this.car.item_invoicedate_sold))
    },

    debtorsWithOptionalInvoiceDateSold() {
      return this.debtors.filter(debtor => debtor.item_requires_invoicedate_sold === 'N')
    },

    canBookDebts() {
      return this.hasInvoiceDateSold || this.debtorsWithOptionalInvoiceDateSold.length > 0
    }
  },

  created() {
    this.loadDebtors()
  },

  methods: {
    async loadDebtors() {
      if (this.$wait.is('loading debtors')) {
        return
      }

      this.$wait.start('loading debtors')
      const [error, debtors] = await getDebtors()
      this.$wait.end('loading debtors')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Debitoren konnten nicht geladen werden']
        })
        return
      }

      this.debtors = debtors
    },

    focusInvoiceDateSoldField() {
      this.$refs.generalDataForm.focusInvoiceDateSoldField()
    }
  }
}
</script>
